import { render, staticRenderFns } from "./IconRejected.vue?vue&type=template&id=180dcfc5&"
import script from "./IconRejected.vue?vue&type=script&lang=js&"
export * from "./IconRejected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports